import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from '../stores/app'
import { createOrganization } from '../lib/api'
import { getErrorMessage } from '../lib/errors'

const INDUSTRIES = [
  { value: 'consulting', label: 'Consultoría' },
  { value: 'technology', label: 'Tecnología' },
  { value: 'finance', label: 'Finanzas' },
  { value: 'healthcare', label: 'Salud' },
  { value: 'education', label: 'Educación' },
  { value: 'retail', label: 'Retail' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'media', label: 'Media y Entretenimiento' },
  { value: 'real_estate', label: 'Bienes Raíces' },
  { value: 'other', label: 'Otro' },
]

export function OnboardingPage() {
  const navigate = useNavigate()
  const setCurrentUser = useAppStore((state) => state.setCurrentUser)
  const currentUser = useAppStore((state) => state.currentUser)
  const setOrganizationId = useAppStore((state) => state.setOrganizationId)

  const [name, setName] = useState('')
  const [industry, setIndustry] = useState('')
  const [website, setWebsite] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim()) return

    setLoading(true)
    setError(null)

    try {
      const org = await createOrganization({
        name: name.trim(),
        industry: industry || null,
        website: website.trim() || null,
      })

      setOrganizationId(org.id)

      if (currentUser) {
        setCurrentUser({
          ...currentUser,
          organization_id: org.id,
          role: 'admin',
        })
      }

      navigate('/dashboard', { replace: true })
    } catch (err) {
      setError(getErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-emerald-600 text-white font-bold text-xl mb-4">
            S
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Crea tu organización</h1>
          <p className="text-slate-500 mt-2">
            Configura el espacio de trabajo para tu equipo.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="org-name" className="block text-sm font-medium text-slate-700 mb-1">
                Nombre de la organización <span className="text-red-500">*</span>
              </label>
              <input
                id="org-name"
                type="text"
                className="input w-full"
                placeholder="Ej. STRTGY Consulting"
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={loading}
                autoFocus
                required
              />
            </div>

            <div>
              <label htmlFor="org-industry" className="block text-sm font-medium text-slate-700 mb-1">
                Industria
              </label>
              <select
                id="org-industry"
                className="input w-full"
                value={industry}
                onChange={(e) => setIndustry(e.target.value)}
                disabled={loading}
              >
                <option value="">Selecciona una industria...</option>
                {INDUSTRIES.map(({ value, label }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="org-website" className="block text-sm font-medium text-slate-700 mb-1">
                Sitio web
              </label>
              <input
                id="org-website"
                type="url"
                className="input w-full"
                placeholder="https://ejemplo.com"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
                disabled={loading}
              />
            </div>

            {error && (
              <div className="rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !name.trim()}
              className="btn btn-primary w-full"
            >
              {loading ? 'Creando organización...' : 'Crear organización'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
